<template>
<div class="col-md-3 left_col menu_fixed">
  <div class="left_col scroll-view">
    <div class="navbar nav_title" style="border: 0;">
      <router-link :to="{ name: 'tasks' }" class="site_title">
        <span>
          {{ title ? title : 'Edexis' }}
        </span>
      </router-link>
    </div>

    <div class="clearfix"></div>

    <!-- sidebar menu -->
    <div id="sidebar-menu" class="main_menu_side hidden-print main_menu">
      <div class="menu_section active">
        <ul class="nav side-menu" style="">
          <li v-for="item in menuItems">
            <router-link exact :to="{ name: item.name }">
              <i :class="item.icon" class="fa"></i>
              {{ item.title }}
              <span
                v-if="typeof item.pill !== 'undefined'"
                class="label label-success pull-right"
              >
                {{ item.pill }}
              </span>
            </router-link>
          </li>
        </ul>
      </div>

    </div>
    <!-- /sidebar menu -->

    <!-- /menu footer buttons -->
    <div class="sidebar-footer">
      <h5 
        class="hidden-sm time"
      >
        {{ time }}
      </h5>
      <a 
        v-on:click.prevent="logoutPress()"
        class="pointer pull-right"
      >
        <span class="glyphicon glyphicon-off" aria-hidden="true"></span>
      </a>
    </div>
    <!-- /menu footer buttons -->
  </div>
</div>

</template>

<script>
export default {
  name: 'sidebar',
  props: {
    title: {
      String
    },
    menuItems: {
      type: Array
    },
    logout: {
      type: Function
    }
  },
  data () {
    return {
      time: ''
    }
  },
  mounted () {
    this.updateTime()
  },
  methods: {
    logoutPress () {
      this.logout()
    },
    updateTime () {
      setInterval(() => {
        let d = new Date()
        let month = (((d.getMonth() + 1) < '10') ? '0' : '') + (d.getMonth() + 1)
        let dates = ((d.getDate() < 10) ? '0' : '') + d.getDate()
        let year = d.getFullYear()
        let hours = ((d.getHours() < 10) ? '0' : '') + d.getHours()
        let minutes = ((d.getMinutes() < 10) ? '0' : '') + d.getMinutes()
        let seconds = ((d.getSeconds() < 10) ? '0' : '') + d.getSeconds()

        let formatedString = month + '/' + dates + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds
        this.$set(this, 'time', formatedString)
      }, 1000)
    }
  }
}
</script>

<style scoped lang="less">
  .pointer {
    cursor: pointer;
  }

  .site_title span {
    text-align: center;
    display: block;
  }

  .sidebar-footer {
    .time {
      margin-left: 20px;
      margin-top: 10px;
      display: inline-block;
    }
  }

  .nav-sm {
    .sidebar-footer {
      position: absolute;
      width: 100%;
      bottom: 0px;
      a {
        width: 100%
      }
      .time {
        font-size: 13px;
        text-align: center;
        margin-left: 0px;
      }
    }
  }
  li a.router-link-active {
    border-right: 5px solid #1ABB9C;  
    text-shadow: rgba(0,0,0,.25) 0 -1px 0;
    background: linear-gradient(#334556,#2C4257),#2A3F54;
    box-shadow: rgba(0,0,0,.25) 0 1px 0, inset rgba(255,255,255,.16) 0 1px 0;
  }
  
</style>



// WEBPACK FOOTER //
// Sidebar.vue?6a644dda